import React from 'react'
import styled from 'styled-components'
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LineShareButton,
  LineIcon
} from 'react-share'

const shareUrl = 'https://slack-remind-creator.netlify.com/'

const ShareButtons = () => (
  <ShareButtonWrapper>
    <FacebookShareButton url={shareUrl}>
      <FacebookIcon size={40} round />
    </FacebookShareButton>
    <TwitterShareButton url={shareUrl}>
      <TwitterIcon size={40} round />
    </TwitterShareButton>
    <LineShareButton url={shareUrl}>
      <LineIcon size={40} round />
    </LineShareButton>
  </ShareButtonWrapper>
)

export default ShareButtons

const ShareButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;
  .SocialMediaShareButton {
    display: inline-block;
    cursor: pointer;

    &:focus {
      overflow: hidden;
      outline: none;
    }

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`
